/**
 * Max length filed input
 */

export const MAX_LENGTHS = {
  MAX_5: 5,
  MAX_7: 7,
  MAX_8: 8,
  MAX_10: 10,
  MAX_12: 12,
  MAX_15: 15,
  MAX_30: 30,
  MAX_46: 46,
  MAX_50: 50,
  MAX_100: 100,
  MAX_200: 200,
  MAX_255: 255,
};
